import { useEffect } from "react";
import PaymentService from '../../Services/payment.services';
import credentialService from "../../Services/credential.services";

import { useNavigate } from "react-router-dom";
import { sidebarStore } from "../store/SidebarStore";


export default function PaymentPage(props:any)  {
    useEffect(()=>{
        GetIntellipayWidget();
    },[]); 
    const navigate = useNavigate();
    const postPaymentSuccess = async (response:any) => {

        let paymentAmount = response.amount;

        let postPaymentPayload = {
          isAnnualPayment: true,
          totalAnnualPrice: paymentAmount,
          pricePerMonth: paymentAmount,
          shouldCreateFirstPayment: true,
          isFirstPaymentPaid: true,
          IntelliPayTransactionId: response?.receiptelements?.transid || "N/A",
          IntelliPayCustId : String(response?.custid || ""),
        }
        try {
          await PaymentService.PostPayment(postPaymentPayload);
          sidebarStore.setCanCreateNewRequest(true);
          // No next payment is scheduled: credentialing is pay as you go, not a
          // subscription.
          let url = await credentialService.GetNextPage();
          navigate("/"+url, { replace: true });
    
        } catch (error) {
          throw error
        }
      }

    const GetIntellipayWidget = async()=>{
        var response= await PaymentService.GetIntellipayWidget()
        if(response.success){
            var rg=document.createRange();
            var fragment = rg.createContextualFragment(response.data);

            const initializeWidget = () => {
                // @ts-ignore
                intellipay.initialize();
                    // @ts-ignore
                intellipay.runOnApproval(function(response){
                    postPaymentSuccess(response);
                    });

                    // @ts-ignore
                intellipay.runOnNonApproval(function(response){
                    });

                props.onWidgetReady?.();
            }

            const externalScripts = Array.from(fragment.querySelectorAll("script")).filter(script => script.src);
            if(externalScripts.length){
                let remaining = externalScripts.length;
                externalScripts.forEach(script => script.addEventListener("load", () => {
                    remaining -= 1;
                    if(remaining === 0){
                        initializeWidget();
                    }
                }, { once: true }));
            } else {
                document.documentElement.appendChild(fragment);
                initializeWidget();
                return;
            }

            document.documentElement.appendChild(fragment);
        }
    }
 return (
 <div>
 <input className="ipayfield" data-ipayname="amount" type="hidden" value={props.paymentAmount} />
 <input className="ipayfield" data-ipayname="account" type="hidden" value={props.userId} />
 <input className="ipayfield" data-ipayname="email" type="hidden" value={props.userEmail} />
 </div>
 );
}



